import scale from "@ecco/ui/tokens/space";

import { getRelativeWidthToVW } from "@ecco/ui/relative-width";

export const styles = {
    container: {
        display: "flex",
        justifyContent: "space-between",
        fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
        fontWeight: "bold",
    },
    part: {
        lineHeight: "base",
        fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
        fontWeight: "bold",
    },
    tooltipIcon: {
        display: "block",
        cursor: "pointer",
        position: "relative",
    },
    tooltip: {
        flex: "flex-end",
        display: "flex",
        p: 4,
        mr: [0, 0, 0, 4],
        border: `${scale["0.2"]} solid`,
        width: [getRelativeWidthToVW(30), getRelativeWidthToVW(30), getRelativeWidthToVW(30), 320],
        maxWidth: "unset",
        ml: [3, 3, 3, 0],
    },
};
